export enum OnlineEventType {
  VIDEO = 'Video',
  LIVESTREAM = 'Livestream',
  LIVESTREAM_VIDEO = 'LivestreamVideo'
}
